import React from 'react';
import './logo.scss';
export default function Logo() {
    return (React.createElement("span", { className: "logo-wrapper streamlined" },
        React.createElement("span", { className: "logo" },
            React.createElement("a", { href: "/", "aria-label": "OpenStax", "data-analytics-link": true },
                React.createElement("img", { src: "/dist/images/topnav-openstax.svg", alt: "OpenStax logo", width: "147", height: "111" }))),
        React.createElement("span", { className: "logo-divider", "aria-hidden": "true" }),
        React.createElement("span", { className: "rice-logo" },
            React.createElement("a", { href: "/", "aria-label": "OpenStax home", "data-analytics-link": true },
                React.createElement("img", { src: "/dist/images/topnav-rice.svg", alt: "Rice University logo", width: "194", height: "111" })))));
}
